import React, { useEffect, useState } from 'react';
import { string, bool, array } from 'prop-types';
import { connect, useSelector } from 'react-redux';
import get from 'lodash/get';
import StockTickrList from './stock-tickr-list';
import { data } from './config';
import { useInterval } from '../../../../helpers/custom-hooks';
import { isWithinTradingHours } from '../../../../helpers/utils';
import { useInView } from 'react-intersection-observer';

const StockTickrWrapper = ({ sectionName, pageType }) => {
  const [tickerData, setTickerData] = useState([]);
  const { ref, inView } = useInView();
  const [initialCall, setInitialCall] = useState(true);
  const tradingHolidays = useSelector((state) =>
    get(state, ['qt', 'config', 'features', 'trading_holidays'], []),
  );
  const specialTradingDays = useSelector((state) =>
    get(state, ['qt', 'config', 'features', 'special_trading_days'], {}),
  );

  const getTickerData = () => {
    // blocking the api request if the current pathname includes "misc"
    if (window.location.pathname.includes('misc')) {
      return; // Prevent the request
    }

    fetch(`/foapi/market/topTicker`)
      .then((res) => res.json())
      .then((response) => {
        setTickerData([...response.data]);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useInterval(() => {
    if (isWithinTradingHours(tradingHolidays, specialTradingDays) && inView) {
      getTickerData();
    }
  }, 45000);

  useEffect(() => {
    if (initialCall && inView) {
      getTickerData();
      setInitialCall(false);
    }
  }, [inView]);

  return (
    <div ref={ref}>
      {tickerData.length > 0 ? (
        <StockTickrList
          data={tickerData}
          config={data}
          pageType={pageType}
          sectionName={sectionName}
        />
      ) : null}
    </div>
  );
};

StockTickrWrapper.propTypes = {
  clientHost: string,
  sectionName: string,
  sectionSlug: string,
  pageType: string,
  enabledSections: array,
  isWatchlistUrl: bool,
};

const mapStateToProps = (state) => ({
  clientHost: get(
    state,
    ['qt', 'config', 'publisher', 'client_host'],
    'https://www.ndtvprofit.com',
  ),
  enabledSections: get(state, ['qt', 'config', 'features', 'market_ticker_sections'], []),
  isWatchlistUrl: get(state, ['userDetails', 'isWatchlistTab'], false),
});

export default connect(mapStateToProps, {})(StockTickrWrapper);
